export const FINGERPRINTS = {
    PREVIEW: 'Preview',
    RICHTEXTEDITOR: 'RichTextEditor',
};
